<template>
  <div class="app__loader">
    <div class='loader'></div>
  </div>
</template>

<script>
  export default {}
</script>
